export const LADE_SPRACHTEXTE = "ladeSprachTexte";
